import React from 'react';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import { auth, db } from '../firebase';
import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

import { MdSmartToy } from 'react-icons/md';
import { FaArrowDown } from 'react-icons/fa';

import bg from '../assets/arcanes_home_background.jpg';
import logo from '../assets/arcanes_home_logo.png';
import './Auth.css';

function Login() {
  const navigate = useNavigate();

  const handleGoogleLogin = async () => {
    const provider = new GoogleAuthProvider();
    try {
      const result = await signInWithPopup(auth, provider);
      const user = result.user;
      const userDocRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userDocRef);
      if (!userDoc.exists()) {
        await setDoc(userDocRef, {
          uid: user.uid,
          email: user.email,
          signInMethod: 'google',
          createdAt: serverTimestamp(),
        });
      }
      alert('Logged in with Google successfully!');
      navigate('/');
    } catch (error) {
      console.error('Error signing in with Google:', error);
      alert('Error signing in with Google: ' + error.message);
    }
  };

  return (
    <div
      className="login-page"
      style={{
        backgroundImage: `url(${bg})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
      }}
    >
      <div className="login-center">
        <MdSmartToy className="robot-icon" />
        <img src={logo} alt="Arcanes Logo" className="login-logo" />
        <p className="login-tagline">
          A creative hub to build and share practical AI Agents.
        </p>

        <div className="login-action-box">
          <p className="login-action-text">
            Create your own AI Agent with ease.
          </p>
          <FaArrowDown className="arrow-icon" />
          <button className="auth-button" onClick={handleGoogleLogin}>
            Continue with Google
          </button>
          {/*
          <button className="auth-button" onClick={handleAppleLogin}>
            Continue with Apple
          </button>
          */}
        </div>

        <div className="login-footer">
          <span className="footer-link">Privacy Policy</span>
          <span className="footer-dot">&bull;</span>
          <span className="footer-link">Terms and Conditions</span>
        </div>
      </div>
    </div>
  );
}

export default Login;
